import { render, staticRenderFns } from "./TargetSettingApproval.vue?vue&type=template&id=c1f4a308&scoped=true"
import script from "./TargetSettingApproval.vue?vue&type=script&lang=js"
export * from "./TargetSettingApproval.vue?vue&type=script&lang=js"
import style0 from "./TargetSettingApproval.vue?vue&type=style&index=0&id=c1f4a308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f4a308",
  null
  
)

export default component.exports